import 'react-app-polyfill/ie11';
import { createLazyComponent } from '@republic/spellcaster/components';
export default {
  url: "/webview/cancel",
  name: "webview:cancel",
  params: {},
  component: createLazyComponent('LazyCancellationWebviewPage', {}, {
    "canonical": "/webview/cancel",
    "noindex": true
  }, () => import(
  /* webpackChunkName: "CancellationWebviewPage-a7769313" */
  '/var/lib/jenkins/workspace/builds-web/relay-web/relay/relay/src/accounts/components/CancellationWebviewPage.js').then(({
    default: component
  }) => component))
};